import { render, staticRenderFns } from "./role-details.vue?vue&type=template&id=a87d2564&scoped=true&"
import script from "./role-details.vue?vue&type=script&lang=js&"
export * from "./role-details.vue?vue&type=script&lang=js&"
import style0 from "./role-details.vue?vue&type=style&index=0&id=a87d2564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d2564",
  null
  
)

export default component.exports